var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';
import { Dropdown, Icon, Tooltip } from '@cimpress/react-components';
import 'react-dropdown/style.css';
import CustomLoadingOverlay from '../CustomLoadingOverlay';
import { capitalize, colorStyle, disableGridCell, getCombinedErrorMessage, isEmptyArray } from '../../utils/utils';
import PriceCellRenderer from '../PriceCellRenderer';
import MarginCellRenderer from '../MarginCellRenderer';
import { getDropdownOptionsForSku } from '../../utils/PricingGridLayoutUtils';
import cloneDeep from 'lodash/cloneDeep';
import PricingChart from '../charts/PricingChart';

var GrossMarginLayout =
/** @class */
function (_super) {
  __extends(GrossMarginLayout, _super);

  function GrossMarginLayout() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      rowData: undefined,
      dropdownList: {
        cost: {
          selected: {
            value: undefined
          }
        },
        price: {
          selected: {
            value: undefined
          }
        }
      },
      grossMarginHeader: []
    };

    _this.componentDidUpdate = function (prevProps, prevState) {
      var _a = _this.props,
          results = _a.results,
          grossMarginSelections = _a.grossMarginSelections;
      var dropdownList = _this.state.dropdownList;

      if (results && results.headers && !isEqual(prevProps.results && prevProps.results.headers, results.headers)) {
        _this.refreshGrid();
      } else if (!isEqual(prevProps.results.rowData, results.rowData) || !isEqual(prevState.dropdownList, dropdownList)) {
        if (results && results.headers) {
          _this.setColumnDefinitions();
        }

        _this.setRowData();
      }

      if (JSON.stringify(prevProps.grossMarginSelections) !== JSON.stringify(grossMarginSelections)) {
        _this.refreshGrid();
      }
    };

    _this.setPinnedHeaderContent = function () {
      if (_this.props.results) {
        var headers = _this.props.results.headers;

        if (headers && _this.gridApi && _this.gridApi.headerRootComp.ePinnedLeftHeader) {
          var pinnedHeaderName = headers && headers.pinned ? headers.pinned.name : 'Quantity';
          _this.gridApi.headerRootComp.ePinnedLeftHeader.innerHTML = "<div class='ag-grid-quantity'><span class='quantity-text'>" + capitalize(pinnedHeaderName) + "</span></div>";
        }
      }
    };

    _this.onDisplayedColumnsChanged = function (params) {
      params.api.sizeColumnsToFit();

      _this.setPinnedHeaderContent();
    };

    _this.setRowData = function () {
      var _a = _this.props,
          results = _a.results,
          showGrossMarginChart = _a.showGrossMarginChart;
      var rowData = null;

      if (results && !isEmptyArray(results.rowData)) {
        rowData = results.rowData;
      }

      if (rowData) {
        _this.addMargin(rowData);

        _this.setState({
          rowData: rowData
        });
      } else if (_this.gridApi) {
        _this.setState({
          rowData: null
        }, function () {
          if (!showGrossMarginChart) {
            try {
              _this.gridApi.showLoadingOverlay();
            } catch (e) {// Block to catch edge case when grid is mounted and unmounted in successions
            }
          }
        });

        setTimeout(function () {
          if (!_this.state.rowData) {
            _this.setState({
              rowData: []
            });
          }
        }, 25000);
      }
    };

    _this.addMargin = function (rowData) {
      var cost;
      var price;

      if (_this.state.dropdownList && _this.state.dropdownList.cost) {
        cost = _this.state.dropdownList.cost.selected.value;
      }

      if (_this.state.dropdownList && _this.state.dropdownList.price) {
        price = _this.state.dropdownList.price.selected.value;
      }

      rowData.forEach(function (row) {
        var c = 0;
        var p = 0;
        var margin;
        Object.keys(row).forEach(function (key) {
          if (key === cost) {
            if (row[key] && row[key].productPrice && row[key].productPrice.totalPrice) c = row[key].productPrice.totalPrice;
          }

          if (key === price) {
            if (row[key] && row[key].productPrice && row[key].productPrice.totalPrice) p = row[key].productPrice.totalPrice;
          }
        });
        if (p && c) margin = (p - c) / p * 100;

        if (margin !== undefined) {
          row.Margin = {
            productPrice: {
              totalPrice: margin.toFixed(2) + "%",
              displayPrice: margin.toFixed(2) + "$"
            }
          };
        } else {
          row.Margin = {
            productPrice: undefined
          };
        }
      });
    };

    _this.onDropdownSelection = function (selectedItem, sku) {
      var grossMarginHeader = [];

      _this.setState(function (prevState) {
        var _a;

        var dropdownList = prevState.dropdownList;
        dropdownList = __assign(__assign({}, dropdownList), (_a = {}, _a[sku] = __assign(__assign({}, dropdownList[sku]), {
          selected: selectedItem
        }), _a));
        grossMarginHeader = [dropdownList.price.selected, dropdownList.cost.selected];
        return {
          dropdownList: dropdownList,
          grossMarginHeader: grossMarginHeader
        };
      });

      _this.props.grossMarginSelectionChange(selectedItem, sku);
    };

    _this.setColumnDefinitions = function () {
      var columnsDefinition = [];
      var results = _this.props.results;
      var dropdownList = _this.state.dropdownList;

      if (results && results.headers) {
        var headers = results.headers;

        if (headers && headers.headerPrice && headers.headerPrice.pinned) {
          var pinnedHeader = headers.headerPrice.pinned;
          columnsDefinition[0] = {
            headerName: capitalize(pinnedHeader.name),
            field: pinnedHeader.value,
            minWidth: 140,
            filter: 'agTextColumnFilter',
            cellRendererFramework: PriceCellRenderer,
            pinned: 'left',
            lockPinned: true,
            cellClass: 'pinnedCellStyle',
            sortable: true,
            unSortIcon: true,
            rowDrag: true,
            width: 150,
            suppressMovable: true,
            suppressSizeToFit: true,
            headerClass: 'header-class-test'
          };
          columnsDefinition[3] = {
            headerName: capitalize('Margin'),
            field: 'Margin',
            minWidth: 140,
            filter: 'agTextColumnFilter',
            cellRendererFramework: MarginCellRenderer,
            type: 'numericColumn',
            headerComponentFramework: function headerComponentFramework(params) {
              return React.createElement("span", {
                className: "span-grid-style"
              }, params.displayName);
            }
          };
        }

        var index_1 = 1;
        ['price', 'cost'].forEach(function (sku) {
          var children = [];
          var skuDropdown = dropdownList[sku];

          if (skuDropdown) {
            var cell = {
              headerName: capitalize(sku),
              minWidth: 162,
              filter: 'agTextColumnFilter',
              cellRendererFramework: PriceCellRenderer,
              field: undefined,
              type: '',
              headerComponentFramework: undefined,
              cellStyle: function cellStyle(params) {
                if (disableGridCell(params.value)) return {
                  background: '#E6E6E6'
                };
                return undefined;
              }
            };
            cell.field = skuDropdown.selected.value;
            cell.type = 'numericColumn';
            var header = skuDropdown.selected;
            var errorMessage = header.errorMessage,
                errorType = header.errorType,
                shippingErrorMessage = header.shippingErrorMessage,
                shippingErrorType = header.shippingErrorType;
            var message_1 = getCombinedErrorMessage(errorMessage, shippingErrorMessage);
            var color_1;

            if (shippingErrorType) {
              color_1 = shippingErrorType;
            }

            if (errorType) {
              color_1 = errorType;
            }

            cell.headerComponentFramework = function () {
              var selectedTitle = message_1 && color_1 ? React.createElement("div", null, React.createElement(Tooltip, {
                direction: "top",
                contents: message_1
              }, React.createElement(Icon, {
                color: colorStyle[color_1],
                name: "report-problem-triangle-f"
              }), React.createElement("span", {
                style: {
                  marginLeft: '5px'
                }
              }, skuDropdown.selected.label))) : skuDropdown.selected.label;
              return React.createElement("div", {
                className: "merchant-style",
                style: {
                  borderRight: '1px solid #bdc3c7'
                }
              }, React.createElement(Dropdown, {
                title: selectedTitle,
                className: "merchant-selector"
              }, skuDropdown.dropdownOptions.map(function (option, idx) {
                return (// eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                  React.createElement("a", {
                    key: option.label + "-" + option.value,
                    onClick: function onClick() {
                      return _this.onDropdownSelection(option, sku);
                    }
                  }, option.label)
                );
              })));
            };

            children.push(cell);
            columnsDefinition[index_1] = {
              children: children,
              headerClass: '',
              headerName: "Select a " + capitalize(sku),
              minWidth: 150,
              resizable: true,
              headerComponentFramework: function headerComponentFramework(params) {
                return React.createElement("span", {
                  className: "span-grid-style"
                }, params.displayName);
              }
            };
            index_1 += 1;
          }
        });
      }

      if (_this.gridApi) {
        _this.gridApi.setColumnDefs(columnsDefinition);
      }
    };

    _this.onGridReady = function (params) {
      _this.gridApi = params.api;

      _this.setPinnedHeaderContent();

      _this.setColumnDefinitions();
    };

    return _this;
  }

  GrossMarginLayout.prototype.componentDidMount = function () {
    if (this.props.results && this.props.results.headers) {
      this.refreshGrid();
    }
  };

  GrossMarginLayout.prototype.refreshGrid = function () {
    var _this = this;

    var dropdownList = {};
    var _a = this.props,
        results = _a.results,
        grossMarginSelections = _a.grossMarginSelections;
    var grossMarginHeader = [];

    if (has(results, 'headers') && !isEmpty(results.headers)) {
      var _b = results.headers,
          headerPrice = _b.headerPrice,
          headerCost = _b.headerCost;
      var dropdownOptions = getDropdownOptionsForSku(headerPrice.headerList, false);

      if (dropdownOptions && dropdownOptions.length) {
        dropdownOptions = dropdownOptions.flat();
        dropdownList.price = {
          dropdownOptions: dropdownOptions,
          selected: grossMarginSelections && grossMarginSelections.price ? grossMarginSelections.price : dropdownOptions[0]
        };
        grossMarginHeader.push(dropdownList.price.selected);
      }

      dropdownOptions = getDropdownOptionsForSku(headerCost.headerList, false);

      if (dropdownOptions && dropdownOptions.length) {
        dropdownOptions = dropdownOptions.flat();
        dropdownList.cost = {
          dropdownOptions: dropdownOptions,
          selected: grossMarginSelections && grossMarginSelections.cost ? grossMarginSelections.cost : dropdownOptions[0]
        };
        grossMarginHeader.push(dropdownList.cost.selected);
      }
    }

    this.setState({
      dropdownList: dropdownList,
      grossMarginHeader: grossMarginHeader
    }, function () {
      _this.setColumnDefinitions();

      _this.setRowData();
    });
  };

  GrossMarginLayout.prototype.render = function () {
    var defaultColDef = {
      cellClass: 'defaultCellStyle'
    };
    var frameworkComponents = {
      customLoadingOverlay: CustomLoadingOverlay
    };
    return React.createElement("div", null, !this.props.showGrossMarginChart ? React.createElement("div", {
      className: "ag-theme-balham ag-grid-custom-style ag-no-pivot-style pivot-grid"
    }, React.createElement(AgGridReact, {
      rowData: cloneDeep(this.state.rowData),
      rowHeight: 45,
      headerHeight: 45,
      gridAutoHeight: true,
      rowDragManaged: true,
      animateRows: true,
      suppressMovableColumns: true,
      suppressCellSelection: true,
      defaultColDef: defaultColDef,
      onDisplayedColumnsChanged: this.onDisplayedColumnsChanged,
      onGridReady: this.onGridReady,
      frameworkComponents: frameworkComponents,
      loadingOverlayComponent: "customLoadingOverlay"
    })) : React.createElement("div", {
      className: "chart-section"
    }, React.createElement("div", {
      className: "chart-section-nested-div"
    }, React.createElement(PricingChart, {
      gridData: this.state.rowData,
      headers: this.state.grossMarginHeader,
      priceMode: this.props.priceMode,
      contracts: this.props.contracts,
      sellers: this.props.sellers,
      currency: this.props.currency,
      logger: this.props.logger
    }))));
  };

  GrossMarginLayout.defaultProps = {
    widthOfQuantity: 200
  };
  return GrossMarginLayout;
}(Component);

export default GrossMarginLayout;